import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ContractProvider } from './contexts/ContractContext';
import HomePage from './components/HomePage';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <Router>
          <ContractProvider>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </div>
          </ContractProvider>
        </Router>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;